const validate = require("jquery-validation")

export function formAjax(param) {
	var validator = $(".form-ajax");

	validator.each(function () {
		$(this).validate(
			{
				rules: {
					buscar: {
						required: true
					},
					name: {
						required: true,
						minlength: 3
					},
					phone: {
						required: true,
						minlength: 14
					},
					email: {
						required: true,
						email: true
					},
					state: {
						required: true,
					},
					subject: {
						required: true,
					},
					terms: {
						required: true
					},
					message: {
						required: true,
						minlength: 10
					},
				},
				messages: {
					buscar: {
						required: "Campo obrigatório",
						minlength: "Mínimo 2 caracteres"
					},
					name: {
						required: "Por favor, informe seu nome",
						minlength: "O nome deve ter pelo menos 3 caracteres"
					},
					phone: {
						required: "Por favor, informe seu telefone",
						minlength: "O telefone deve ter DDD e número válido"
					},
					email: {
						required: "É necessário informar um e-mail",
						email: "É necessário informar um e-mail válido",
					},
					state: {
						required: "Campo obrigatório"
					},
					subject: {
						required: "Selecione uma opção"
					},
					terms: {
						required: "É necessário aceitar os termos"
					},
					message: {
						required: "Campo obrigatório",
						minlength: "O nome deve ter pelo menos 10 caracteres"
					}
				},
				errorPlacement: function(error, element) 
				{
					if ( element.is(":radio") ) 
					{
						error.appendTo( element.closest('.wrap-form').find('.validateError') );
					}
					else 
					{  
						error.appendTo( element.closest('.wrap-form').find('.validateError') );
						// error.insertAfter( element );
					}
				}
			}
		);
	});

}

export function contatos() {
	var validator = $('.form-contatos');
	var uploads = $('input[type=file]');

	validator.each(function () {
		$(this).validate({
			ignore: [],
			rules: {
				name: {
					required: true,
					minlength: 3
				},
				phone: {
					required: true,
					minlength: 14
				},
				email: {
					required: true,
					email: true
				},
				address: {
					required: true
				},
				number: {
					required: true
				},
				neighborhood: {
					required: true
				},
				zipcode: {
					required: true
				},
				state: {
					required: true
				},
				city: {
					required: true
				},
				numberUser: {
					required: true
				},
				sizeArea: {
					required: true
				},
				nameCompany: {
					required: true,
					minlength: 3
				},
				acting: {
					required: true,
					minlength: 3
				},
				message: {
					required: true,
					minlength: 10
				},
				'select-interesses': {
					required: true
				},
				userfile: {
					required: true
				},
				areaField: {
					required: true
				},
				earthlyRelationship: {
					required: true
				}

			},
			messages: {
				name: {
					required: "Campo obrigatório*",
					minlength: "O nome deve ter pelo menos 3 caracteres*"
				},
				phone: {
					required: "Campo obrigatório*",
					minlength: "O telefone deve ter DDD e número válido*"
				},
				email: {
					required: "Campo obrigatório*",
					email: "É necessário informar um e-mail válido*",
				},
				address: {
					required: "Campo obrigatório*"
				},
				number: {
					required: "Campo obrigatório*"
				},
				neighborhood: {
					required: "Campo obrigatório*"
				},
				zipcode: {
					required: "Campo obrigatório*"
				},
				state: {
					required: "Campo obrigatório*"
				},
				city: {
					required: "Campo obrigatório*"
				},
				numberUser: {
					required: "Campo obrigatório*"
				},
				sizeArea: {
					required: "Campo obrigatório*"
				},
				nameCompany: {
					required: "Campo obrigatório*",
					minlength: "Necessário ter pelo menos 3 caracteres*"
				},
				acting: {
					required: "Campo obrigatório*",
					minlength: "Necessário ter pelo menos 3 caracteres*"
				},
				message: {
					required: "Campo obrigatório*",
					minlength: "Necessário pelo menos 10 caracteres"
				},
				'select-interesses': {
					required: "Campo obrigatório*"
				},
				userfile: {
					required: "Campo obrigatório*"
				},
				areaField: {
					required: "Campo obrigatório*",
				},
				earthlyRelationship: {
					required: "Campo obrigatório*",
				}

			},

			// highlight: function(element, errorClass) {
			// 	if($(element).attr('type') == 'file'){
			// 		console.log('eh file')
			// 	}
			//   }

		});


	});


	uploads.each(function () {

		var _this = this;

		_this.onchange = function () {

			let nameFile = this.value;
			var _parent = this.closest(".form-control");

			_parent.querySelector('.error-file').style.display = 'none';
			_parent.querySelector('.p-name-file').style.display = 'none';

			if (nameFile) {
				var sizeFile = this.files[0].size;

				if (sizeFile > 8000000) {
					_parent.querySelector('.error-file').style.display = 'block';
				} else {
					_parent.querySelector('.error-file').style.display = 'none';
					_parent.querySelector('.p-name-file').style.display = 'block';
					if (this.classList.contains("error")) {
						this.classList.remove("error");
						_parent.querySelector("#" + this.getAttribute('id') + '-error').remove();
					}
				}

				nameFile = this.value.split(/(\\|\/)/g).pop();
				_parent.querySelector('.name-file').innerHTML = nameFile;

			} else {
				_parent.querySelector('.name-file').innerHTML = '';
			}

		}


		$(this).rules('add', {
			accept: "image/*,.pdf",
			messages: {
				accept: "Formato inválido."
			}
		});
	})

}

export function sendFormWhats() {
	var validator = $('.form-send-whats');

	validator.validate({
		rules: {
			nome: {
				required: true,
				minlength: 3
			},
			email: {
				required: true,
				email: true
			},
			telefone: {
				required: true,
				minlength: 14
			},
		},
		messages: {
			nome: {
				required: "Campo obrigatório*",
				minlength: "O nome deve ter pelo menos 3 caracteres*"
			},
			email: {
				required: "Campo obrigatório*",
				email: "É necessário informar um e-mail válido*",
			},
			telefone: {
				required: "Campo obrigatório*",
				minlength: "O telefone deve ter DDD e número válido*"
			},
		}
	})
}